const urls = {
    KNOWT_TAKERS: "https://p3hfek8muyu.typeform.com/to/amZkSNSo",
    DMCA_TAKEDOWN_REQUEST: "https://airtable.com/appOQ60Ha2ExbRtqD/shrJ6uvoMURquZOSC",
};

export default urls;
